import { api } from "lib";
import apiFormData from "lib/apiFormData";

export const exportEmployeeAccumulateTemplate = async (params = {}) => {
    return await api.post("/v1/employee/exportUploadEmployeeAccumulateTemplate", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const importEmployeeAccumulateData = async (params = {}) => {
    return await apiFormData.post("/v1/employee/importEmployeeAccumulateData", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const importEmployeeCheckInData = async (params = {}) => {
    return await apiFormData.post("/v1/employee/importEmployeeCheckInData", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const exportEmployeeCheckInTemplate = async (params = {}) => {
    return await api.post("/v1/employee/exportUploadEmployeeCheckInTemplate", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const importFundMembership = async (params = {}) => {
    return await apiFormData.post("/v1/fund-memberships/import", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const exportFundImportTemplate = async (params = {}) => {
    return await api.post("/v1/fund-memberships/exportFundImportTemplateXlsx", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};